<div class="calendar-day">
  <div class="calendar-day__header">
    <div class="calendar-day__header-left">
      <button mat-icon-button (click)="onClickBack()" matTooltip="back to month">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h4 class="calendar-day__title">{{ selectedDate() | date: 'yyyy-MM-dd' }}</h4>
    </div>
    <div class="calendar-day__header-right">
      <button mat-icon-button (click)="onClickPrevious()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickNext()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="calendar-day__wrapper">
    @for (timespan of schedulePreview(); track timespan; let i = $index) {
      <rc-calendar-timespan
        [offset]="timespan.offset"
        [duration]="timespan.duration"
        [periodLength]="timespan.length"
        [showLegend]="schedulePreview().length === i + 1"
      ></rc-calendar-timespan>
    }
  </div>
</div>

<ng-template #item let-label="label" let-isSkipped="isSkipped">
  <span class="calendar-day__item">{{ label }}</span>
</ng-template>
